export const mapping = { type: 'geo_shape' }
export const sanitizeData = (cfg, data) => JSON.parse(data)
